import Request from '@/plugins/request';

export function getOrderImportDetails(params) {
  return Request.get('order-import-details', { params })
}

export function createOrderImportDetail() {
  return Request.get(`order-import-details/create`)
}

export function storeOrderImportDetail(data) {
  return Request.post('order-import-details', data)
}

export function updateOrderImportDetail(id, data) {
  return Request.put(`order-import-details/${id}`, data)
}

export function editOrderImportDetail(id) {
  return Request.get(`order-import-details/${id}/edit`)
}

export function destroyOrderImportDetail(id) {
  return Request.delete(`order-import-details/${id}`)
}
